    $(document).ready(function() {      
        $(window).on("scroll", function() {
            var fromTop = $(window).scrollTop();
            $("body").toggleClass("down", (fromTop > 50));        

            if ($(window).width() < 767) {
              if(fromTop > 50){
                
                  //var htmlString= $("#mobile_nav").html();
               //alert(htmlString);
                	//	$("#mobile_nav_clone").html(htmlString);
              }
              else{
              		// var htmlString= $("#mobile_nav_clone").html();
                	//	$("#mobile_nav").html(htmlString);
              }
              
            }          
        });
      
     
    });